<template>
    <div
        class="feed-url add-show-step-1"
    >
        <slot />
        <p class="title">
            Enter your show RSS URL
        </p>
        <form
            novalidate
            @submit.prevent="processForm"
        >
            <div class="input-group">
                <input
                    v-model="url"
                    class="feed-url-input"
                    :disabled="formProcessing"
                    type="text"
                    @click="errorMessage = ''"
                >
                <span
                    v-if="'' !== errorMessage"
                    class="error-message rss-error-message"
                >
                    {{ errorMessage }}
                </span>
            </div>
                <transition
                    name="fade"
                    mode="out-in"
            >
                <base-form-button
                    v-if="!formProcessing"
                    key="button"
                    class="btn"
                    :has-arrow="true"
                >
                    Let's Get Started
                </base-form-button>
                <div
                    v-else
                    key="message"
                    class="loading-message"
                >
                    <i
                        key="spinner"
                        class="fas fa-spinner fa-spin"
                    />
                    Loading your podcast information. Please wait...
                </div>
            </transition>
        </form>
        <a class="feed-rss-url" href="https://support.fusebox.fm/article/438-find-rss-url">Where can I find my RSS URL?</a>
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import toasts from '@/mixins/toasts';

export default {
    mixins: [toasts],

    data: () => ({
        formProcessing: false,
        url: '',
        errorMessage: '',
        showHash: null,
    }),

    methods: {

        /**
         * Validate if input is not empty
         *
         * @returns  {boolean} If field is valid
         */
        validate() {
            if ('' === this.url) {
                this.errorMessage = 'Please enter show RSS URL';
                return false;
            }

            return true;
        },

        /**
         * Handle process form action
         *
         */
        async processForm() {
            if (! this.validate()) {
                return;
            }

            const { status, data } = await apiCall(this, 'post', '/api/shows/import', { feedUrl: this.url });

            if (200 !== status) {
                if (data?.errors?.feedUrl[0]) {
                    this.errorMessage = data.errors.feedUrl[0];
                }

                this.toastError({
                    message: {
                        title: data.message || data,
                    },
                });

                return;
            }

            this.$emit('change-step', data);
        },
    },
};
</script>
